import Logo from 'components/icons/Logo';
import PlusSign from 'components/icons/signUp/PlusSign';
import Usaa from 'components/icons/Usaa';

const UsaaBanner = () => {
  return (
    <section className="flex justify-center p-4 text-center font-normal shadow-sm">
      <div className="bp2:flex">
        <div className="max-w-100 flex justify-center p-4">
          <Logo className="w-28 pt-2" />
          <div className="pr-2 pt-8">
            <PlusSign />
          </div>
          <Usaa className="max-h-14 max-w-xs" />
        </div>
        <div className="max-w-2xl flex-auto pt-4">
          <h5 className="text-xl font-medium text-green-100">Discount for USAA Members</h5>
          <h6 className="mx-2 my-0 text-lg font-medium leading-6 text-charcoal-80">
            Save 50% On Your First Box Plus 15% On Future Boxes**
          </h6>
        </div>
      </div>
    </section>
  );
};

export default UsaaBanner;
